import React from 'react';
import { makeStyles } from '@mui/styles';
import { Tab, Tabs } from '@mui/material';

import POWDocumentsTab from './POWDocuments/POWDocumentsTab';
import MembershipDocumentsTab from './MembershipDocuments/MBDocumentsTab';
import UploadedDocumentsTab from './UploadedDocuments/UploadedDocumentsTab';
import { TabPanel, a11yProps } from '../../../../../../common/utils/TabPanel';
import {
  CONSUMER_PROFILE_TABS,
  useCustomerProfileQueryParams
} from '../../useCustomerProfileQueryParams';

const useStyles: any = makeStyles((theme: any) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    display: 'flex',
    backgroundColor: theme.palette.background.paper
  },
  tabs: {
    width: '240px',
    minWidth: '200px',
    justifyContent: 'flex-start',
    borderRight: `1px solid ${theme.palette.divider}`
  },
  tLeft: {
    '& .MuiTab-wrapper': {
      justifyContent: 'flex-start'
    }
  }
}));

export enum DocumentType {
  MEMBERSHIP = "MEMBERSHIP",
  CORE_WAIVER = "CORE_WAIVER",
  LEGACY_MEMBERSHIP = "LEGACY_MEMBERSHIP"
}

function DocumentsTabs(props: any) {
  const classes = useStyles();
  const { customerAllData } = props;
  const [{ subTab }, setQuery] = useCustomerProfileQueryParams();

  const subTabs = CONSUMER_PROFILE_TABS['documents'];
  const currentIndex = Math.max(
    subTabs.findIndex(t => t === subTab),
    0
  );
  const handleChange = (_: unknown, newIndex: number) => {
    setQuery({ tab: 'documents', subTab: subTabs[newIndex] });
  };

  return (
    <div className={classes.root}>
      <Tabs
        value={currentIndex}
        centered={true}
        textColor="primary"
        scrollButtons="auto"
        orientation="vertical"
        onChange={handleChange}
        indicatorColor="primary"
        className={classes.tabs}
      >
        <Tab {...a11yProps(0)} label="POW" className={classes.tLeft} />
        <Tab {...a11yProps(1)} label="Uploaded" className={classes.tLeft} />
        <Tab {...a11yProps(2)} label="Mind Body" className={classes.tLeft} />
      </Tabs>
      <div style={{ width: '100%' }}>
        <TabPanel value={currentIndex} index={0}>
          <POWDocumentsTab customerAllData={customerAllData} />
        </TabPanel>
        <TabPanel value={currentIndex} index={1}>
          <UploadedDocumentsTab customerAllData={customerAllData} />
        </TabPanel>
        <TabPanel value={currentIndex} index={2}>
          <MembershipDocumentsTab customerAllData={customerAllData} />
        </TabPanel>
      </div>
    </div>
  );
}

export default DocumentsTabs;
